<template>
  <div>
    <v-navigation-drawer
      id="nav"
      app
      :color="$vuetify.theme.themes.light.secondary"
      dark
      width="260"
      :value="drawer"
      v-if="isLoggedIn"
    >
      <template v-slot:img="attrs">
        <v-img
          v-bind="attrs"
          gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
        />
      </template>
      <v-divider class="mx-3 mb-3" />
      <v-list-item
        v-if="
          role.indexOf('Broker Plan Admin') > -1 ||
          role.indexOf('Broker Plan Manager') > -1 ||
          role.indexOf('Employer Plan Admin') > -1 ||
          role.indexOf('Documents Management Admin') > -1 ||
          role.indexOf('Employer Members Viewer') > -1 ||
          role.indexOf('Employer Premiums Viewer') > -1 ||
          role.indexOf('Employer Billing Viewer') > -1 ||
          role.indexOf('Member Portal Admin') > -1 ||
          role.indexOf('Member Portal Users Admin') > -1
        "
      >
        <v-list-item-action @click="loadUserPlans">
          <auto-select
            style="min-width: 200px"
            clear-icon="clear"
            :value.sync="selectedObj.Plan"
            :items="plans"
            :label="
              $t('components.vuematerialdashboard.core.drawer.switch_plan')
            "
            :slots="true"
            :filter="filterFunc"
            :loading="loading"
            item-value="Id"
          >
            <template v-slot:selection="data">
              {{ planDescription(data.item) }}
              <span :class="statusClass(data.item)">
                {{ status(data.item) }}
              </span>
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="planDescription(data.item)"
              ></v-list-item-content>
              <span :class="statusClass(data.item)">
                {{ status(data.item) }}
              </span>
            </template>
          </auto-select>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-3 mb-3" />

      <v-list nav>
        <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
        <div />
        <v-list-item
          :to="'/plan/' + selectedObj.Plan.Id + '/home'"
          active-class="primary white--text"
          v-if="
            (selectedObj.Plan !== null && selectedObj.Plan !== undefined) ||
            ((role.indexOf('Global Support Manager') > -1 ||
              role.indexOf('Broker Support Admin') > -1) &&
              role.indexOf('Broker Plan Manager') == -1 &&
              role.indexOf('Broker Plan Admin') == -1 &&
              role.indexOf('Employer Plan Admin') == -1 &&
              role.indexOf('Employer Members Viewer') == -1 &&
              role.indexOf('Employer Premiums Viewer') == -1 &&
              role.indexOf('Employer Billing Viewer') == -1)
          "
        >
          <v-list-item-action>
            <v-icon>dashboard</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.drawer.dashboard") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/plan-parameters'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>insert_drive_file</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("globals.plan") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (selectedObj.Plan.PlanType === 'HW' ||
              selectedObj.Plan.PlanType === 'Pension') &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Employer Members Viewer') > -1)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/members'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>assignment_ind</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.membersmanagementtable.members") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/employers'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>work</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("globals.employers") }}
          </v-list-item-title>
        </v-list-item>

        <!-- <v-list-item
          v-if="
            selectedObj.Plan !== null &&
              selectedObj.Plan !== undefined &&
              (role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Employer Plan Admin') > -1 ||
                role.indexOf('Employer Members Viewer') > -1 ||
                role.indexOf('Employer Premiums Viewer') > -1 ||
                role.indexOf('Employer Billing Viewer') > -1)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/billing'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>attach_money</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{
              $t(
                "components.vuematerialdashboard.core.drawer.billing_&_premiums"
              )
            }}
          </v-list-item-title>
        </v-list-item> -->

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            selectedObj.Plan.PlanType === 'HW' &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Employer Premiums Viewer') > -1 ||
              role.indexOf('Employer Billing Viewer') > -1)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/contributions-control'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>attach_money</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{
              $t(
                "components.vuematerialdashboard.core.drawer.contributions_control"
              )
            }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            selectedObj.Plan.PlanType === 'HW' &&
            role.indexOf('Broker Plan Manager') > -1
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/balance-payments'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>account_balance_wallet</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{
              $t("components.vuematerialdashboard.core.drawer.balance_payments")
            }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            selectedObj.Plan.PlanType === 'HW' &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1) &&
            planOptions &&
            (planOptions.HasT4A || planOptions.HasDemographics)
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/reports'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>insert_chart</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.drawer.reporting") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Documents Management Admin') > -1) &&
            planIdentity
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/documents-centre'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>backup</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.drawer.documents_center") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (selectedObj.Plan.PlanType === 'HW' ||
              selectedObj.Plan.PlanType === 'Pension') &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Member Portal Admin') > -1 ||
              role.indexOf('Member Portal Users Admin') > -1) &&
            planIdentity &&
            (planIdentity.HasDrupalPortal ||
              planIdentity.Id === '3fac62fc-573d-4e6c-9fb4-c8d80075168f') &&
            planIdentity.MembersPortal &&
            planIdentity.MembersPortal.IsActive
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/portal'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>web</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.drawer.portal") }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Member Portal Admin') > -1 ||
              role.indexOf('Member Portal Users Admin') > -1) &&
            planIdentity &&
            (!planIdentity.HasDrupalPortal ||
              planIdentity.Id === '3fac62fc-573d-4e6c-9fb4-c8d80075168f') &&
            planIdentity.MembersPortal &&
            planIdentity.MembersPortal.IsActive
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/portal-view'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>web</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.drawer.portal") }}
          </v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          v-if="
            selectedObj.Plan !== null &&
              selectedObj.Plan !== undefined &&
              (role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Content Editor') > -1) &&
              planIdentity &&
              !planIdentity.MembersPortal
          "
          :to="'/plan/' + selectedObj.Plan.Id + '/portal-content'"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>web</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.drawer.portal") }}
          </v-list-item-title>
        </v-list-item> -->

        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            selectedObj.Plan !== undefined &&
            ((!selectedObj.Plan.UseISeriesClaims &&
              selectedObj.Plan.PlanType === 'HW') ||
              selectedObj.Plan.PlanType === 'Pension') &&
            role.indexOf('Claims Administrator') > -1
          "
          :to="'/claims/' + selectedObj.Plan.Id"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>medical_services</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.appbar.claims") }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="
            selectedObj.Plan !== null &&
            payload.Json.canOptout &&
            selectedObj.Plan !== undefined
          "
          :to="'/opt-outs/' + selectedObj.Plan.Id"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>mdi-account-minus</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.appbar.opt_outs") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          active-class="primary white--text"
          @click="helpDialog = true"
        >
          <v-list-item-action>
            <v-icon>help_center</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.drawer.need_help") }}
          </v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          v-if="selectedObj.Plan !== null && selectedObj.Plan !== undefined && role.indexOf('Broker Plan Manager') > -1"
          :to="'/helpdesk/' + selectedObj.Plan.Id"
          active-class="primary white--text"
        >
          <v-list-item-action>
            <v-icon>mdi-tag-heart-outline</v-icon>
          </v-list-item-action>

          <v-list-item-title>
            {{ $t("components.vuematerialdashboard.core.appbar.helpdesk") }}
          </v-list-item-title>
        </v-list-item> -->
      </v-list>

      <template v-slot:append></template>
    </v-navigation-drawer>
    <error-handler :error="error"></error-handler>
    <v-dialog v-model="helpDialog" max-width="700" persistent scrollable>
      <material-card
        :title="$t('components.drawer.need_help').toUpperCase()"
        :color="$vuetify.theme.themes.light.secondary"
        icon="help_center"
      >
        <!-- <v-card-text> -->
        <div class="help-info-container">
          <span style="margin-top: 20px" class="help-info-text">
            {{ $t("components.drawer.help1") }}
          </span>
          <span class="help-info-text">
            {{ $t("components.drawer.help2") }}
          </span>
          <span style="margin-top: 20px" class="help-info-text">
            <b>{{ $t("components.drawer.help3") }}</b>
          </span>
          <span class="help-info-text">
            {{ $t("components.drawer.help4") }}
          </span>
          <span class="help-info-text">
            {{ $t("components.drawer.help5") }}
            <a href="mailto:ask.on@pbas.ca">ask.on@pbas.ca</a>
          </span>
        </div>
        <!-- </v-card-text> -->
        <v-card-actions>
          <v-btn color="primary" @click="helpDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
// Utilities
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
// eslint-disable-next-line
import { connect } from "net";
import ErrorHandler from "@/components/ErrorHandler";
import { translate2 } from "../../../trans2";
import AutoSelect from "@/components/AutoSelect";
import SettingsService from "@/services/settings.service.js";

export default {
  components: {
    ErrorHandler,
    AutoSelect,
  },
  computed: {
    ...mapGetters("navbar", ["drawer"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["plan", "plans"]),
    ...mapState("app", ["image", "color"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
  },
  data() {
    return {
      helpDialog: false,
      error: null,
      selected: "",
      payload: {
            Json: {},
          },
      selectedObj: {
        Plan: null,
      },
      opened: false,
      loading: false,
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path === "/") {
          this.selected = "dashboard";
        } else {
          this.selected = this.$route.path.split("-")[0];
        }
      },
    },
    plan: {
      handler() {
        this.selectedObj.Plan = this.plan;
      },
    },
    "selectedObj.Plan": {
      async handler(v) {
        console.log(
          "selected plan changed in drawer: ",
          this.selectedObj.Plan,
          this.$router.currentRoute
        );
        if (
          this.selectedObj.Plan &&
          ((this.plan && this.selectedObj.Plan.Id !== this.plan.Id) ||
            !this.plan)
        ) {
          await this.loadPlanData();
          try {
            // this.setPlan(this.selectedObj.Plan);
            // await this.getPlanOptions(this.selectedObj.Plan.Id);
            if (
              this.$router.currentRoute.params.planId !== null &&
              this.$router.currentRoute.params.planId !== undefined &&
              this.$router.currentRoute.params.planId !==
                this.selectedObj.Plan.Id
            ) {
              if (
                this.$router.currentRoute.name.indexOf("contributions") > -1
              ) {
                if (this.planOptions && this.planOptions.HasBillingImport) {
                  this.$router.push({
                    name: this.$router.currentRoute.name,
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                } else {
                  this.$router.push({
                    name: "homeWithPlan",
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                }
              } else if (
                this.$router.currentRoute.name.indexOf("t4a") > -1 ||
                this.$router.currentRoute.name.indexOf("demographics") > -1 ||
                this.$router.currentRoute.name.indexOf("reports") > -1
              ) {
                if (
                  this.planOptions &&
                  (this.planOptions.HasT4A || this.planOptions.HasDemographics)
                ) {
                  this.$router.push({
                    name: this.$router.currentRoute.name,
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                } else {
                  this.$router.push({
                    name: "homeWithPlan",
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                }
              } else if (
                this.$router.currentRoute.name.indexOf("memberView") > -1 ||
                this.$router.currentRoute.name.indexOf("emailCallback") > -1 ||
                this.$router.currentRoute.name.indexOf("members") > -1 ||
                this.$router.currentRoute.name.indexOf(
                  "dependantsImportWizard"
                ) > -1 ||
                this.$router.currentRoute.name.indexOf("premiums") > -1 ||
                this.$router.currentRoute.name.indexOf("remittance") > -1 ||
                this.$router.currentRoute.name.indexOf("reviseWizard") > -1 ||
                this.$router.currentRoute.name.indexOf("billing") > -1 ||
                // this.$router.currentRoute.name.indexOf("commissionsTable") > -1 ||
                this.$router.currentRoute.name.indexOf("trustFund") > -1 ||
                this.$router.currentRoute.name.indexOf("insuranceCarriers") >
                  -1 ||
                this.$router.currentRoute.name.indexOf("coverage") > -1 ||
                this.$router.currentRoute.name.indexOf("eligibility") > -1 ||
                this.$router.currentRoute.name.indexOf("reports") > -1 ||
                this.$router.currentRoute.name.indexOf("addMemberWizard") >
                  -1 ||
                this.$router.currentRoute.name.indexOf("searchMembersForm") >
                  -1 ||
                this.$router.currentRoute.name.indexOf("balance") > -1 ||
                this.$router.currentRoute.name.indexOf("payments") > -1 ||
                this.$router.currentRoute.name.indexOf("pending") > -1 ||
                this.$router.currentRoute.name.indexOf("hours") > -1 ||
                this.$router.currentRoute.name.indexOf("employers") > -1 ||
                this.$router.currentRoute.name.indexOf("searchEmployersForm") >
                  -1 ||
                this.$router.currentRoute.name.indexOf("employer") > -1 ||
                this.$router.currentRoute.name.indexOf("portalPlanSettings") >
                  -1
              ) {
                this.$router.push({
                  name: "homeWithPlan",
                  params: { planId: this.selectedObj.Plan.Id },
                });
              } else if (
                this.$router.currentRoute.name.indexOf("portal") > -1 ||
                this.$router.currentRoute.name.indexOf("downloadCenter") > -1 ||
                this.$router.currentRoute.name.indexOf("sidebarItems") > -1 ||
                this.$router.currentRoute.name.indexOf("welcomeKit") > -1 ||
                this.$router.currentRoute.name.indexOf("drugs") > -1 ||
                this.$router.currentRoute.name.indexOf("benefitCards") > -1 ||
                this.$router.currentRoute.name.indexOf("providers") > -1 ||
                this.$router.currentRoute.name.indexOf("adminFiles") > -1
              ) {
                if (
                  this.planIdentity &&
                  this.planIdentity.HasDrupalPortal &&
                  this.planIdentity.MembersPortal &&
                  this.planIdentity.MembersPortal.IsActive
                ) {
                  this.$router.push({
                    name: this.$router.currentRoute.name,
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                } else {
                  this.$router.push({
                    name: "homeWithPlan",
                    params: { planId: this.selectedObj.Plan.Id },
                  });
                }
              } else {
                this.$router.push({
                  name: this.$router.currentRoute.name,
                  params: { planId: this.selectedObj.Plan.Id },
                });
              }
            } else if (
              this.$router.currentRoute.params.planId === null ||
              this.$router.currentRoute.params.planId === undefined
            ) {
              this.$router.push({
                name: "homeWithPlan",
                params: { planId: this.selectedObj.Plan.Id },
              });
            }
          } catch (error) {
            this.error = error;
          }

          // if (
          //   this.$router.currentRoute.name !== "emailCallback" &&
          //   this.$router.currentRoute.name !== "home" &&
          //   this.$router.currentRoute.name !== "selectPlan" &&
          //   (this.$router.currentRoute.name !== "homeWithPlan" ||
          //   this.$router.currentRoute.params.planId!==this.selectedObj.Plan.Id)
          // )
          //   this.$router.push({ name: "homeWithPlan", params: { planId: this.selectedObj.Plan.Id} });
        }
      },
    },
  },
  beforeDestroy() {
    if (this.observer != null) this.observer.disconnect();
  },
  async mounted() {
    if (this.selectedObj.Plan !== null && this.selectedObj.Plan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapMutations("navbar", ["setDrawer", "toggleDrawer"]),
    ...mapActions("navbar", ["updateDrawer"]),
    ...mapActions("common", ["setPlan", "setNavbarOpen", "setPlans"]),
    ...mapActions("plansMembers", ["getPlanOptions", "getUserPlans"]),
    ...mapActions("auth", ["getUser", "silentRefresh", "login"]),
    ...mapActions("portalsProxy", ["getPlanPortalConfiguration"]),
    planDescription(plan) {
      if (plan === null || plan === undefined) {
        return "";
      }
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    filterFunc(item, search) {
      return (
        this.planDescription(item).toLowerCase().indexOf(search.toLowerCase()) >
        -1
      );
    },
    async loadPlanData() {
      try {
        const item = (
          await this.getPlanPortalConfiguration({
            planIdentityId: this.selectedObj.Plan.Id,
          })
        ).data;
        if (item !== null && item !== undefined && item != "") {
          this.payload = item; //JSON.stringify(item, null, 2);
          this.payload.UseLegacyClaims = this.selectedObj.Plan.UseISeriesClaims;
        } else {
          this.payload = {
            Json: {},
          };
        }
      } catch (error) {
        console.log(error);
        this.payload = {
          Json: {},
        };
      }
    },
    status(item) {
      if (item === null || item === undefined) return "";
      return item.Current.IsTesting ? " Test " : " Live ";
    },
    statusClass(item) {
      if (item === null || item === undefined) return "";
      return item.Current.IsTesting ? "test-plan" : "live-plan";
    },
    async loadUserPlans() {
      try {
        this.loading = true;
        var usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
          if (this.plan) {
            this.selectedObj.Plan = this.plan;
          }
        }
      } catch (error) {
        console.log("silent refresh error: ", error);
        this.login();
      } finally {
        this.loading = false;
      }
    },
    toggleNav() {
      // this.opened = !this.opened;
      this.toggleDrawer();
    },
  },
};
</script>
<style scoped>
.plan-switcher /deep/ .v-select__selections input {
  display: none;
}
.help-info-text {
  font-size: 18px;
  margin-left: auto;
  margin-right: auto;
}
.help-info-container {
  padding: 16px;
  display: contents;
  /* font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.0071428571em; */
}
</style>
<style>
.test-plan {
  background-color: red;
  color: white;
  font-size: 12px;
  margin: 5px;
}
.live-plan {
  background-color: green;
  color: white;
  font-size: 12px;
  margin: 5px;
}
</style>
